import AwsServices from '../api/AwsServices.js';
import { useState } from 'react';

export const useGetSignedUrlAndUploadFile = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const mutate = async (body) => {
    setLoading(true);
    setError(null);
    try {
      const { data: urlResponse } = await AwsServices.getSignedUrl({
        filename: body.filename,
        contentType: body.contentType,
        partnerId: body.partnerId
      });

      const uploadResult = await AwsServices.uploadFile({
        url: urlResponse?.url,
        file: body.file,
        contentType: body.contentType,
      });

      setData(uploadResult);
      setLoading(false);
      return uploadResult;
    } catch (err) {
      setError(err);
      setLoading(false);
      throw err;
    }
  };

  return { mutate, loading, error, data };
};
